import React from "react";
import { useColorModeValue, Box } from "@chakra-ui/react";
import { STYLE_PANEL, STYLE_PANEL_SHADOW } from "constants/AppConstants";
import colors from "theme/colors";

export const BoxPanel = (props) => {
  const { variant, children, ...rest } = props;
  const panelBg = useColorModeValue(
  colors.light.boxpanel_style_color,
  colors.dark.boxpanel_style_color
);

const panelShadow = useColorModeValue(
  colors.light.boxpanel_style_shadow,
  colors.dark.boxpanel_style_shadow
);

  return (
    <Box
      border="1px solid"
      borderColor="rgba(255,255,255,0.05)"
      bg={panelBg}
      boxShadow={panelShadow}
      mt="10px"
      borderRadius="16px"
      {...rest}
    >
      {children}
    </Box>
  );
};
